/**
 * Places outside VACARS5 that pilots are sent to (2026-10-11). The guide is the
 * one copy on myVAC (deploy-myvac.sh publishes docs/VACARS5-Pilot-Guide.pdf
 * there), so a new guide reaches pilots without a VACARS5 release. In the
 * desktop app these open in the pilot's browser (main.js setWindowOpenHandler).
 */
export const PILOT_GUIDE_URL = "https://myvac.flyvac.org/res/VACARS5-Pilot-Guide.pdf";
// The pilot's myVAC logbook, where each flight with a debrief has an icon that
// opens it (2026-10-19, docs/patches/vacars5_debriefs.php).
export const MYVAC_PROFILE_URL = "https://myvac.flyvac.org/profile.php#logbook";
